<template>
<v-card flat>
  <template v-if='withTitle' >
    <v-card-title v-if='locationId' >
      Editing {{locationName}} ({{spaceName}})
    </v-card-title>
    <v-card-title v-else >
      Add a new location for {{spaceName}}
      <v-spacer></v-spacer>
      <!-- <v-btn color="primary" >Save</v-btn> -->
    </v-card-title>
  </template>
  <v-card-text>
    <v-row>
      <v-col cols-xs="12" cols="6" >
        <data-form
          v-on="$listeners"
          v-model='location'
          :fields='fields'
          :request='request'
          :trigger-save='saveToucher' >
        </data-form>
      </v-col>
      <v-col class='hidden-xs' cols="6" >
        <v-card tile flat >
          <v-card-title class='overline py-0 black white--text' >
            Preview
          </v-card-title>
          <v-divider />
          <location-card v-if='location.name' v-model='location' />
          <v-skeleton-loader v-else tile
            :boilerplate='true'
            class='mx-auto'
            type="card-avatar, article, actions" />
          <!-- <pre v-text='place'  /> -->
          <v-card-actions v-if='locationId' >
            <v-btn
              v-if='withDelete'
              :loading='deleteRequest.loading'
              @click='performDelete(location.id)' color='error' >
              Delete {{location.name}}
            </v-btn>
            <v-spacer/>
            <v-btn @click='saveToucher++' color='primary' >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
  <!-- <pre v-text='place' /> -->
</v-card>
</template>
<script>
// import AddressPicker from '@/components/pickers/AddressPicker.vue'
import LocationFormMixin from './forms/LocationFormMixin.js'
import DataForm from '@/components/data/DataForm.vue'
import LocationCard from '@/components/cards/LocationCard.vue'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LocationForm',
  components: {
    DataForm,
    LocationCard
  },
  mixins: [LocationFormMixin],
  props: {
    spaceId: { required: true },
    locationId: { required: false },
    withTitle: { type: Boolean, default: true },
    withDelete: { type: Boolean, default: true },
  },
  data () {
    return {
      saveToucher: 0,
      location: {
        is_virtual: false
      },
      request: {
        resource: 'ag.spaces',
        extra: 'addresses',
        method: 'patch'
      },
      deleteRequest: {
        resource: 'ag.spaces',
        extra: 'addresses',
        method: 'delete'
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getLocationBySpaceAndId']),
    place () {
      if (this.location && this.location.place) { return this.location.place }
      return null
    },
    placeId () {
      if (this.location && this.location.place) { return this.location.place.id }
      return null
    },
    configString () {
      return this.spaceId + this.locationId
    },
    storeLocation () {
      return this.getLocationBySpaceAndId(this.spaceId, this.locationId)
    },
    locationName () {
      if (this.location) {
        return this.location.name
      }
      return ''
    },
    locationRequestStatus () {
      return this.request.status
    }
  },
  methods: {
    performDelete (locationId) {
      if (locationId) {
        this.deleteRequest.resourceId = this.spaceId
        this.deleteRequest.extra = `addresses/${locationId}`
        this.$request('delete', this.deleteRequest)
      } else {
        console.error('No locationId specified')
      }
    },
    get () {
      this.request.resourceId = this.spaceId
      this.request.extra = 'addresses/' + this.locationId
      this.$request('get', this.request)
    },
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    locationId: {
      immediate: true,
      handler () {
        if (this.locationId) {
          this.get()
        }
      }
    },
    location () {
      this.$emit('input', this.location)
    },
    configString: {
      immediate: true,
      handler () {
        if (this.storeLocation) {
          this.location = this.clone(this.storeLocation)
          // this.request.extra = `addresses/${this.locationId}/`
          // Vue.set(this.request, 'resourceId', this.storeId)
          Vue.set(this.request, 'method', 'patch')
          Vue.set(this.request, 'extra', `addresses/${this.locationId}`)
          console.log(this.request)
          // console.log('update location:', this.location, this.storeLocation)
        }
      }
    },
    place () {
      if (this.place) {
        Vue.set(this.location, 'title', this.place.name)
        Vue.set(this.location, 'address', this.place.formatted_address)
        Vue.set(this.location, 'place_id', this.place.id)
        Vue.set(this.location, 'place_data', this.place)
        if (this.place.geometry && this.place.geometry.location) {
          Vue.set(this.location, 'latitude', this.place.geometry.location.lat())
          Vue.set(this.location, 'longitude', this.place.geometry.location.lng())
        }
        if (this.place.international_phone_number) {
          Vue.set(this.location, 'phone', this.place.international_phone_number)
        }
        if (this.place.email) { Vue.set(this.location, 'email', this.place.email) }
        if (this.place.website) { Vue.set(this.location, 'website', this.place.website) }
      }
    },
    locationRequestStatus () {
      if (this.locationRequestStatus === 200) {
        this.location = this.request.result
      }
    }
  },
}
</script>
